import { toast } from 'sonner';

import { isCallActive } from '@/features/whatsapp/call-activity';

/**
 * Where the "new version" offer stands in the installed app:
 *   none     - nothing newer is live (or not checked yet);
 *   offered  - the "Update now / Later" toast is up;
 *   deferred - "Later" (or the toast was closed): the header Update chip
 *              stays until they tap it.
 */
export type UpdateStage = 'none' | 'offered' | 'deferred';

let stage: UpdateStage = 'none';
const listeners = new Set<() => void>();

export const getUpdateStage = (): UpdateStage => stage;

export const setUpdateStage = (next: UpdateStage): void => {
  if (stage === next) return;
  stage = next;
  for (const l of listeners) l();
};

export const onUpdateStageChange = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/**
 * Load the new version - a page reload (index.html is never cached, so it
 * brings the new build). Never mid-call: that would cut the customer off.
 */
export const applyUpdate = (reload: () => void = () => window.location.reload()): boolean => {
  if (isCallActive()) {
    toast.info('Finish the call first, then update.');
    setUpdateStage('deferred');
    return false;
  }
  reload();
  return true;
};
